import React, { useEffect, useState } from "react"
import Page from "../../common/page/Page"
import { useDispatch } from "react-redux"
import { addToCart } from "../../data/CartSlice"
import axios from "axios"
import ProductCards from "../../common/ProductCards/ProductCards"
import { useNavigate, useParams } from "react-router-dom"
import style from "./SingleProductPage.module.css"
import RightArrow from "../../icons/RightArrowIcon"
import LeftArrow from "../../icons/LeftArrowICon"
import Cart from "../../icons/Cart"
import FlashOnIcon from "../../icons/FlashOnIcon"
import { useAuth } from "../../data/useAuth"
import Loader from "../../common/loader/Loader"
const SingleProductPage = () => {
  const dispatch = useDispatch()
  // const search = useSelector((state) => state.global.search)
  const [product, setProduct] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { id } = useParams()
  const [index, setIndex] = useState(0)
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        console.log(`/api/products/${id}`)
        const response = await axios.get(`/api/products/${id}`)
        setProduct(response.data.product || null)
        console.log("Products fetched:", response.data.product)
      } catch (err) {
        setError(err.response?.data?.message || err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchProducts()
  }, [id])
  const isOutOfStock = product?.stock == 0

  const calculatePrice = () => {
    if (!product) return "0.00"
    const rate = parseFloat(product.rate || 0)
    const gst = parseFloat(product.product_category?.gst || 0)
    return (rate + (rate * gst) / 100).toFixed(2)
  }

  const [activeTab, setActiveTab] = useState("description")

  return (
    <Page title={product ? product.name : "Product Details"} searchDisabled={true}>
      <div className={style.container}>
        {loading && (
          <div style={{ height: "60vh", display: "flex" }}>
            <div style={{ margin: "auto" }}>
              <Loader />
            </div>
          </div>
        )}
        {error && (
          <div style={{ color: "#ef4444", textAlign: "center", padding: "40px" }}>
            {error}
          </div>
        )}
        {!loading && product && (
          <>
            <div className={style.singleProductPage}>
              {/* Gallery Section */}
              <div className={style.imageSection}>
                <div
                  className={style.mainImageWrapper}
                  style={{ cursor: product.product_images?.length > 1 ? "pointer" : "default" }}
                  onClick={() => {
                    if (product.product_images?.length > 1) {
                      setIndex((prev) => (prev === product.product_images.length - 1 ? 0 : prev + 1))
                    }
                  }}
                >
                  {product.product_images?.[index] && (
                    <img
                      src={`${import.meta.env.VITE_BACKEND_URL}/public/images/products/${product.product_images[index].image_url}`}
                      alt={product.name}
                    />
                  )}

                  {product.product_images?.length > 1 && (
                    <>
                      <button
                        className={`${style.arrowBtn} ${style.arrowLeft}`}
                        onClick={(e) => {
                          e.stopPropagation()
                          setIndex((prev) => (prev === 0 ? product.product_images.length - 1 : prev - 1))
                        }}
                      >
                        <LeftArrow />
                      </button>
                      <button
                        className={`${style.arrowBtn} ${style.arrowRight}`}
                        onClick={(e) => {
                          e.stopPropagation()
                          setIndex((prev) => (prev === product.product_images.length - 1 ? 0 : prev + 1))
                        }}
                      >
                        <RightArrow />
                      </button>
                    </>
                  )}
                </div>

                {/* Thumbnails Row */}
                {product.product_images?.length > 1 && (
                  <div className={style.thumbnailRow}>
                    {product.product_images.map((img, idx) => (
                      <img
                        key={img.id || idx}
                        src={`${import.meta.env.VITE_BACKEND_URL}/public/images/products/${img.image_url}`}
                        alt={`Thumbnail ${idx + 1}`}
                        className={`${style.thumb} ${index === idx ? style.activeThumb : ""}`}
                        onClick={() => setIndex(idx)}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* Product Details Section */}
              <div className={style.detailsSection}>
                {product.product_category?.name && (
                  <span className={style.categoryTag}>{product.product_category.name}</span>
                )}
                <h1 className={style.title}>{product.name}</h1>

                <div className={style.priceBox}>
                  <span className={style.price}>₹{calculatePrice()}</span>
                  {product.product_category?.gst && (
                    <span className={style.gstBadge}>(Incl. {product.product_category.gst}% GST)</span>
                  )}
                </div>

                <div className={`${style.stockStatus} ${isOutOfStock ? style.outOfStock : style.inStock}`}>
                  {isOutOfStock ? "Out of Stock" : "In Stock & Ready to Ship"}
                </div>

                {/* Primary Action Buttons directly below Title & Price */}
                <div className={style.actions}>
                  <button
                    type="button"
                    className={`${style.btn} ${style.cartBtn}`}
                    disabled={isOutOfStock}
                    onClick={() => {
                      if (isLoggedIn) {
                        dispatch(addToCart({ product_id: product.id, qty: 1 }))
                      } else {
                        navigate("/login")
                      }
                    }}
                  >
                    Add to Cart <Cart />
                  </button>
                  <button
                    type="button"
                    className={`${style.btn} ${style.buyBtn}`}
                    disabled={isOutOfStock}
                    onClick={() => {
                      if (isOutOfStock) return
                      navigate(`/order-summary/${product.id}`)
                    }}
                  >
                    Buy Now <FlashOnIcon />
                  </button>
                </div>

                {/* Trust & Guarantee Grid */}
                <div className={style.trustGrid}>
                  <div className={style.trustItem}>
                    <svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-5.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>
                    <span>100% Authentic</span>
                  </div>
                  <div className={style.trustItem}>
                    <svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>
                    <span>Fast Delivery</span>
                  </div>
                  <div className={style.trustItem}>
                    <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
                    <span>Quality Assured</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Full-width Description & How to Use Section */}
            <div className={style.fullWidthSection}>
              <div className={style.tabBar}>
                <button
                  type="button"
                  className={`${style.tabBtn} ${activeTab === "description" ? style.activeTab : ""}`}
                  onClick={() => setActiveTab("description")}
                >
                  Description
                </button>
                {product.user_manual && (
                  <button
                    type="button"
                    className={`${style.tabBtn} ${activeTab === "manual" ? style.activeTab : ""}`}
                    onClick={() => setActiveTab("manual")}
                  >
                    How to Use
                  </button>
                )}
              </div>

              <div className={style.contentCard}>
                {activeTab === "description" && (
                  <p className={style.descriptionText}>{product.description}</p>
                )}

                {activeTab === "manual" && product.user_manual && (
                  <div className={style.manualBox}>
                    <p>{product.user_manual}</p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </Page>
  )
}

export default SingleProductPage
